import { LinkPreviewService } from './link-preview.service';

export default angular
  .module('sfMobile.services.link-preview', [])
  .service('linkPreviewService', LinkPreviewService).name;
